import {
  string as yupString,
} from 'yup';

import CheckboxFormik from '../../shared/forms/checkbox/checkboxFormik.component';
import RadioFormik from '../../shared/forms/radio/radioFormik.component';

import UserInfo from './userInfo.component';
import { hideDecimalsFlagOptions, negativeMinusFlagOptions, displayZeroFlagOptions, shadeGridFlagOptions } from './userProfile.constants';

const schema = [
  {
    name: 'userInfo',
    component: UserInfo,
    meta: { valueGetter: ({ formContext }) => formContext.user },
    options: { readOnly: true },
  },
  {
    name: 'receiveEmailFlag',
    component: CheckboxFormik,
    meta: { label: 'Receive Email Notifications' },
    options: { yupType: yupString() },
    additionalProps: { valueFormatter: Boolean },
  },
  {
    name: 'hideDecimalsFlag',
    component: RadioFormik,
    meta: { label: 'Show Decimal Places', options: hideDecimalsFlagOptions },
    options: { yupType: yupString() },
    additionalProps: { horizontal: true },
  },
  {
    name: 'negativeMinusFlag',
    component: RadioFormik,
    meta: { label: 'Format Negative Numbers', options: negativeMinusFlagOptions },
    options: { yupType: yupString() },
    additionalProps: { horizontal: true },
  },
  {
    name: 'displayZeroFlag',
    component: RadioFormik,
    meta: { label: 'Display Zero/Null Values', options: displayZeroFlagOptions },
    options: { yupType: yupString() },
    additionalProps: { horizontal: true },
  },
  {
    name: 'shadeGridFlag',
    component: RadioFormik,
    meta: { label: 'Shade Alternate Grid Rows', options: shadeGridFlagOptions },
    options: { yupType: yupString() },
    additionalProps: { horizontal: true },
  },
];

export default schema;
